import React, { useState, useEffect } from "react";
import { Box, Typography, Toolbar, IconButton} from "@mui/material";
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import FileUpload from "../componentes/FileUpload";
import BoxTable from "../componentes/tabla/BoxTable";
import DocumentExplorer from "../componentes/DocumentExplorer"
import ChartDisplay from "../componentes/charts/ChartDisplay";
import ConsultaChart from '../componentes/tabla/ConsultaChart';
import axiosInstancePromise from "../general/axiosConfig";
import { styleMainBox1, styleMainBox2 } from "../estilo/Main";


const MainConstestaciones = ({ view, senalTabla }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpanded2, setIsExpanded2] = useState(false);
  const [isExpanded3, setIsExpanded3] = useState(false);
  const [isExpanded4, setIsExpanded4] = useState(true);
  const [isExpanded5, setIsExpanded5] = useState(false);
  const [isExpanded6, setIsExpanded6] = useState(false);
  const [isExpanded7, setIsExpanded7] = useState(false);
  const [isExpanded8, setIsExpanded8] = useState(false);
  const [isExpanded9, setIsExpanded9] = useState(false);
  const [isExpanded10, setIsExpanded10] = useState(false);
  const [isExpanded11, setIsExpanded11] = useState(false);
  const [isExpanded12, setIsExpanded12] = useState(false);
  const [isExpanded13, setIsExpanded13] = useState(false);
  const [isExpanded14, setIsExpanded14] = useState(false);
  const [isExpanded15, setIsExpanded15] = useState(false);
  const [isExpanded16, setIsExpanded16] = useState(false);
  const [isExpanded17, setIsExpanded17] = useState(false);
  const [isExpanded18, setIsExpanded18] = useState(false);
  const [isExpanded19, setIsExpanded19] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [signal, setSignal] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [chartData2, setChartData2] = useState(null);
  const [chartData3, setChartData3] = useState(null);
  const [chartData4, setChartData4] = useState(null);
  const [columns, setColumns] = useState([]);
  const [columns2, setColumns2] = useState([]);
  const [columns3, setColumns3] = useState([]);
  const [columns4, setColumns4] = useState([]);
  const [selectedColumn, setSelectedColumn] = useState('objeciones');
  
  const [vistaActual, setVistaActual] = useState(localStorage.getItem('view') || '');
  const [tablaActual, setTablaActual] = useState('');

  const [selectedTimeRange, setSelectedTimeRange] = useState("año");
  const [selectedTimeRange2, setSelectedTimeRange2] = useState("dia");
  const [selectedTimeRange3, setSelectedTimeRange3] = useState("dia");
  const [selectedTimeRange4, setSelectedTimeRange4] = useState("mes");
  
  const handleToggleExpand1 = () => toggleExpand(setIsExpanded);
  const handleToggleExpand2 = () => toggleExpand(setIsExpanded2, 'tact', 'DocumentosSubidos');
  const handleToggleExpand3 = () => toggleExpand(setIsExpanded3, 'tact', 'DocsSubidosProcesados');
  const handleToggleExpand4 = () => toggleExpand(setIsExpanded4);
  const handleToggleExpand5 = () => toggleExpand(setIsExpanded5, 'tact', 'FacturasRd');
  const handleToggleExpand6 = () => toggleExpand(setIsExpanded6, 'tact', 'soportes');
  const handleToggleExpand7 = () => toggleExpand(setIsExpanded7, 'tact', 'FacturaRdCodigos');
  const handleToggleExpand8 = () => toggleExpand(setIsExpanded8);
  const handleToggleExpand9 = () => toggleExpand(setIsExpanded9);
  const handleToggleExpand10 = () => toggleExpand(setIsExpanded10);
  const handleToggleExpand11 = () => toggleExpand(setIsExpanded11, 'tact', 'Contestaciones');
  const handleToggleExpand12 = () => toggleExpand(setIsExpanded12);
  const handleToggleExpand13 = () => toggleExpand(setIsExpanded13, 'tact', 'FacturasRdContestadas');
  const handleToggleExpand14 = () => toggleExpand(setIsExpanded14, 'tact', 'Contestaciones_enviadas');
  const handleToggleExpand15 = () => toggleExpand(setIsExpanded15, 'tact', 'no_procesados');
  const handleToggleExpand16 = () => toggleExpand(setIsExpanded16, 'tact', 'SoportesSubidos');  
  const handleToggleExpand17 = () => toggleExpand(setIsExpanded17, 'tact', 'ContestacionesAgrupadas');  
  const handleToggleExpand18 = () => toggleExpand(setIsExpanded18, 'tact', 'Informes');  
  const handleToggleExpand19 = () => toggleExpand(setIsExpanded19, 'tact', 'CodigosContestados');  

  const handleHandle = async () => {
    handleToggleExpand2();
    handleToggleExpand5();
    handleToggleExpand17();
  };
  useEffect(() => {
    updateTableData();
    handleHandle();
  }, [senalTabla]);

  useEffect(() => {
    fetchChartData();
    fetchChartData2();
    fetchChartData3();
    fetchChartData4();
    handleHandle();
  }, []);

  const groupByPeriod = (data, period) => {
    const grouped = {};

    data.forEach(({ date, total }) => {
      let key;

      switch (period) {
        case "dia":
          key = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
          break;
        case "mes":
          key = `${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
          break;
        case "año":
          key = `${date.getFullYear()}`;
          break;
        default:
          return;
      }

      grouped[key] = (grouped[key] || 0) + total;
    });

    // Ordenar las claves (etiquetas) cronológicamente
    const sortedKeys = Object.keys(grouped).sort((a, b) => {
      if (period === "año") return Number(a) - Number(b);
      if (period === "mes" || period === "dia") return new Date(a.split("/").reverse().join("-")) - new Date(b.split("/").reverse().join("-"));
      return 0;
    });

    return {
      labels: sortedKeys,
      values: sortedKeys.map((key) => grouped[key]),
    };
  };

  const processChartData = (rawData, selectedTimeRange) => {
    if (!Array.isArray(rawData)) return { finalLabels: [], finalData: [] };

    const parsedData = rawData
      .map(({ Fecha_Ingreso, total }) => ({
        date: new Date(Fecha_Ingreso),
        total,
      }))
      .sort((a, b) => a.date - b.date);

    const { labels, values } = groupByPeriod(parsedData, selectedTimeRange);

    return {
      finalLabels: labels,
      finalData: values,
    };
  };

  const { finalLabels: finalLabels, finalData: finalData } = processChartData(chartData, selectedTimeRange);
  const { finalLabels: finalLabels2, finalData: finalData2 } = processChartData(chartData2, selectedTimeRange2);
  const { finalLabels: finalLabels3, finalData: finalData3 } = processChartData(chartData3, selectedTimeRange3);
  const { finalLabels: finalLabels4, finalData: finalData4 } = processChartData(chartData4, selectedTimeRange4);

  const filteredData = Array.isArray(chartData) ? chartData
    .map(({ Fecha_Ingreso, total }) => ({
      date: new Date(Fecha_Ingreso),
      total,
    }))
    .sort((a, b) => a.date - b.date) // Ordenar por fecha ascendente
  : [];

  const handleTimeRangeChange = (event) => {
    setSelectedTimeRange(event.target.value); 
  };

  const handleTimeRangeChange2 = (event) => {
    setSelectedTimeRange2(event.target.value); 
  };

  const handleTimeRangeChange3 = (event) => {
    setSelectedTimeRange3(event.target.value); 
  };

  const handleTimeRangeChange4 = (event) => {
    setSelectedTimeRange4(event.target.value); 
  };
  
  const updateTableData = async () => {
      try {
        const tablaVista = localStorage.getItem('view');
        if (tablaVista !== 'informes') {
          const axiosInstance = await axiosInstancePromise;
          const response = await axiosInstance.get(`/get-table-general/${tablaVista}`);
          const newData = response.data.rows || [];
          setTableData(newData);
          setSignal((prevSignal) => prevSignal + 1);
        }
      } catch (error) {
        console.error('Error al actualizar los datos de la tabla:', error);
      }
  };
  const fetchChartData = async () => {
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.get("/informes-docsubidos/DocumentosSubidos");
      const newData = response.data.rows || [];
      const allColumns = response.data.columns || [];
      setColumns(allColumns);
      setChartData(newData);
    } catch (error) {
      console.error("Error al actualizar los datos de la tabla:", error);
    }
  };
  
  const fetchChartData2 = async () => {
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.get('/informes-docsubidos/DocsSubidosProcesados');
      const newData = response.data.rows || [];
      const allColumns = response.data.columns2 || [];
      setColumns2(allColumns); 
      setChartData2(newData);
    } catch (error) {
      console.error("Error al actualizar los datos de la tabla:", error);
    }
  };

  const fetchChartData3 = async () => {
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.get('/informes-docsubidos/soportes');
      const newData = response.data.rows || [];
      const allColumns = response.data.columns3 || [];
      setColumns3(allColumns);
      setChartData3(newData);
    } catch (error) {
      console.error("Error al actualizar los datos de la tabla:", error);
    }
  };

  const fetchChartData4 = async () => {
    try {
      const axiosInstance = await axiosInstancePromise;
      const response = await axiosInstance.get(`/informes-docsubidos/Contestaciones_enviadas`);
      const newData = response.data.rows || [];
      const allColumns = response.data.columns4 || [];
      setColumns4(allColumns);
      setChartData4(newData);
    } catch (error) {
      console.error("Error al actualizar los datos de la tabla:", error);
    }
  };

  const toggleExpand = (setState, key = null, value = null) => {
    setState(prev => !prev);
    if (key && value) {
      localStorage.setItem(key, value);
    }
  };
  
  return (
    <Box  sx={{ width: 900, maxWidth: "100%", minHeight: 'fit-content', maxHeight: '2000px', display: 'flex', flexDirection: 'column', flexGrow: 1, overflowY: 'auto', }} >
      <Toolbar />
      {view === "procesador" && (
      <Box sx={{ mt: 2 }}>
        <Box sx={{ placeItems: "center" }}>
          <Box onClick={handleToggleExpand1} sx={styleMainBox1}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>RECEPTOR DE DOCUMENTOS</Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded && (<FileUpload onFileUploadSuccess={updateTableData} />)}
        </Box>
        <Box sx={{ mt:3, borderTop:'1px lightgray solid' }}>
          <Box
            onClick={handleToggleExpand2}
            sx={styleMainBox1}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              GLOSAS CARGADAS EN PLATAFORMA
            </Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded2 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded2 && (
          <Box >
            <BoxTable
              table="DocumentosSubidos"
              data={tableData.length > 0 ? tableData : []}
              signal={signal}
            />
          </Box>
          )}
        </Box>
        <Box sx={{ mt:3, borderTop:'1px lightgray solid' }}>
          <Box
            onClick={handleToggleExpand16}
            sx={styleMainBox1}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              SOPORTES MÉDICOS Y/O ADMINISTRATIVOS
            </Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded16 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded16 && (
          <Box >
            <BoxTable
              table="SoportesSubidos"
              data={tableData.length > 0 ? tableData : []}
              signal={signal}
            />
          </Box>
          )}
        </Box>

        <Box sx={{ mt:3, borderTop:'1px lightgray solid' }}>
          <Box onClick={handleToggleExpand3} sx={styleMainBox1} >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              DOCUMENTOS PROCESADOS
            </Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded3 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded3 && (
          <Box >
            <BoxTable
              table="DocsSubidosProcesados"
              data={[]}
              signal={signal}
            />
          </Box>
          )}
        </Box>
        <Box sx={{ mt:3, paddingBottom:'20px', borderTop:'1px lightgray solid', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand15} sx={styleMainBox1} >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              DOCUMENTOS NO PROCESADOS
            </Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded15 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded15 && (
          <Box >
            <BoxTable
              table="DocsSubidosNoProcesados"
              data={[]}
              signal={signal}
            />
          </Box>
          )}
        </Box>
      </Box>      
      )}
      {view === "soportes" && (
        <Box sx={{ mt:2}}>
          <Box sx={{ placeItems: "center" }}>
            <Box onClick={handleToggleExpand4} sx={styleMainBox1} >
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>EXPLORADOR DE DOCUMENTOS</Typography>
              <IconButton sx={{ p: 0 }}>
                {isExpanded4 ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </Box>
            {isExpanded4 && (<DocumentExplorer />)}
          </Box>
          <Box sx={{ mt:3,paddingBottom:'20px', borderTop:'1px lightgray solid', borderBottom:'1px lightgray solid'}}>
            <Box
              onClick={handleToggleExpand6}
              sx={styleMainBox1}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                REGISTRO DE DOCUMENTOS UNIFICADOS
              </Typography>
              <IconButton sx={{ p: 0 }}>
                {isExpanded6 ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </Box>
            {isExpanded6 && (
            <Box >
              <BoxTable table="soportes" data={[]} signal={signal}/>
            </Box>
           )}
          </Box>
        </Box>
      )}
      {view === "FacturasRd" && (
      <Box sx={{ mt:2}}>
        <Box sx={{ mt:3 ,paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand5} sx={styleMainBox1}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>GLOSAS PROCESADAS</Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded5 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded5 && (
          <Box >
            <BoxTable table={'FacturasRd'} data={tableData.length > 0? tableData: []} signal={signal} />
          </Box >
          )}
        </Box>
        <Box sx={{ mt:3 ,paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand7} sx={styleMainBox1}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>CÓDIGOS DE OBSERVACIONES</Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded7 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded7 && (
          <Box >
            <BoxTable table="FacturaRdCodigos" data={[]} signal={signal}/>
          </Box>
          )}
        </Box>
        <Box sx={{ mt:3 ,paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand13} sx={styleMainBox1}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              GLOSAS CON RESPUESTA GENERADA
            </Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded13 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded13 && (
          <Box >
            <BoxTable table="FacturasRdContestadas" data={[]} signal={signal}/>
          </Box>
          )}
        </Box>
        <Box sx={{ mt:3 ,paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand19} sx={styleMainBox1}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              OBSERVACIONES CON RESPUESTA GENERADA
            </Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded19 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded19 && (
          <Box >
            <BoxTable table="CodigosContestados" data={[]} signal={signal}/>
          </Box>
          )}
        </Box>
      </Box>
      )}

      {view === "Contestaciones" && (
      <Box sx={{ mt:2}}>
        <Box sx={{ mt:3 ,paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand17} sx={styleMainBox1} >
             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>RESPUESTAS PENDIENTES POR GLOSA</Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded17 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded17 && (
          <Box sx={{ overflowX: 'auto' }}>
            <BoxTable table={'ContestacionesAgrupadas'} data={tableData.length > 0? tableData: []} signal={signal} />
          </Box>
          )}
        </Box>
        <Box sx={{ paddingBottom:'15px', borderTop:'1px lightgray solid', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand11} sx={styleMainBox1}>
             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>RESPUESTAS GENERADAS</Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded11 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded11 && (
          <Box sx={{ overflowX: 'auto' }}>
            <BoxTable table={'Contestaciones'} data={tableData.length > 0? tableData: []} signal={signal} />
          </Box>
          )}
        </Box>
        <Box sx={{ paddingBottom:'15px', borderTop:'1px lightgray solid', borderBottom:'1px lightgray solid'}}>
          <Box onClick={handleToggleExpand14} sx={ styleMainBox1}>
             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>RESPUESTAS ENVIADAS</Typography>
            <IconButton sx={{ p: 0 }}>
              {isExpanded14 ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
          </Box>
          {isExpanded14 && (
          <Box sx={{ overflowX: 'auto' }}>
            <BoxTable table={'Contestaciones_enviadas'} data={tableData.length > 0? tableData: []} signal={signal} />
          </Box>
          )}
        </Box>
      </Box>
      )}
      {view === "DiccionarioClientes" && (
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }} align="center">
            DICCIONARIO DE CLIENTES</Typography>
          <Box sx={{ overflowX: 'auto' }}>
            <BoxTable table={'DiccionarioClientes'} data={tableData.length > 0? tableData: []} signal={signal} />
         </Box>
        </Box>
      )}
      {view === "DiccionarioCodigoEsp" && (
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }} align="center">
            DICCIONARIO CÓDIGO ESPECÍFICO</Typography>
          <Box sx={{ overflowX: 'auto' }}>
            <BoxTable table={'DiccionarioCodigoEsp'} data={tableData.length > 0? tableData: []} signal={signal} />
          </Box>
        </Box>
      )}
      {view === "DiccionarioCodigoGen" && (
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }} align="center">
            DICCIONARIO CÓDIGO GENERAL</Typography>
          <Box sx={{ overflowX: 'auto' }}>
            <BoxTable table={'DiccionarioCodigoGen'} data={tableData.length > 0? tableData: []} signal={signal} />
         </Box>
        </Box>
      )}
      {view === "informes" && (
        <Box sx={{ mt: 2 }}>
          <Box sx={{ mt:3 ,paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
            <Box onClick={handleToggleExpand18} sx={styleMainBox1}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>INFORMES GENERADOS</Typography>
              <IconButton sx={{ p: 0 }}>
                {isExpanded18 ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </Box>
            {isExpanded18 && (
            <Box sx={{ overflowX: 'auto' }}>
              <BoxTable table="Informes" data={tableData.length > 0 ? tableData : []} signal={signal} />
            </Box>
            )}
          </Box>
          <Box sx={styleMainBox2}>
            <Box onClick={handleToggleExpand8} sx={styleMainBox1}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>GLOSAS RECIBIDAS</Typography>
              <IconButton sx={{ p: 0 }}>
                {isExpanded8 ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </Box>
            {isExpanded8 && (
              <>
              <ConsultaChart
                selectedTimeRange={selectedTimeRange}
                handleTimeRangeChange={handleTimeRangeChange}
              />
        
              <Box sx={{ mt: 3, width: "85%" }}>
                <ChartDisplay
                  chartType="line"
                  title="Facturas recibidas vs Fechas"
                  data={{
                    labels: finalLabels, // Etiquetas dinámicas basadas en el rango
                    datasets: [
                      {
                        label: "Cantidad",
                        data: finalData, // Datos dinámicos basados en el rango
                        backgroundColor: "rgba(112, 235, 81, 0.6)",
                        borderColor: "rgb(2, 53, 6)",
                        borderWidth: 1,
                      },
                    ],
                  }}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: { position: "top" },
                    },
                  }}
                />
              </Box>
            </>
            )}
        </Box>
          <Box sx={styleMainBox2}>
            <Box onClick={handleToggleExpand9} sx={styleMainBox1} >
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              GLOSAS PROCESADAS
              </Typography>
              <IconButton sx={{ p: 0 }}>
                {isExpanded9 ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </Box>
            {isExpanded9 && (
            <>
            <ConsultaChart
                selectedTimeRange={selectedTimeRange2}
                handleTimeRangeChange={handleTimeRangeChange2}
              />      
            <Box sx={{ mt: 3, width: "85%" }}>
              <ChartDisplay
                chartType="line"
                title="Facturas procesadas vs Fechas"
                data={{
                  labels: finalLabels2, // Etiquetas dinámicas basadas en el rango
                  datasets: [
                    {
                      label: "Cantidad",
                      data: finalData2, // Datos dinámicos basados en el rango
                      backgroundColor: "rgba(243, 114, 114, 0.5)",
                      borderColor: "rgb(56, 3, 3)",
                      borderWidth: 1,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { position: "top" },
                  },
                }}
              />
            </Box>
          </>
  
            )}
          </Box>
          <Box sx={{ mt:3, placeItems: "center", paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
            <Box onClick={handleToggleExpand10} sx={styleMainBox1} >
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                SOPORTES
              </Typography>
              <IconButton sx={{ p: 0 }}>
                {isExpanded10 ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </Box>
            {isExpanded10 && (
            <>
            <ConsultaChart
                selectedTimeRange={selectedTimeRange3}
                handleTimeRangeChange={handleTimeRangeChange3}
              />
            <Box sx={{ mt: 3, width: "85%" }}>
              <ChartDisplay
                chartType="bar"
                title="Soportes vs Fechas"
                data={{
                  labels: finalLabels3, // Etiquetas dinámicas basadas en el rango
                  datasets: [
                    {
                      label: "Cantidad",
                      data: finalData3, // Datos dinámicos basados en el rango
                      backgroundColor: "rgba(235, 224, 72, 0.5)",
                      borderColor: "rgb(187, 175, 6)",
                      borderWidth: 1,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { position: "top" },
                  },
                }}
              />
            </Box>
          </>
  
            )}
          </Box>
          <Box sx={{ mt:3, placeItems: "center", paddingBottom:'20px', borderBottom:'1px lightgray solid'}}>
            <Box onClick={handleToggleExpand12} sx={styleMainBox1} >
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                RESPUESTAS ENVIADAS
              </Typography>
              <IconButton sx={{ p: 0 }}>
                {isExpanded12 ? <ExpandMore /> : <ChevronRight />}
              </IconButton>
            </Box>
            {isExpanded12 && (
            <>
            <ConsultaChart
                selectedTimeRange={selectedTimeRange4}
                handleTimeRangeChange={handleTimeRangeChange4}
              />
            <Box sx={{ mt: 3, width: "85%" }}>
              <ChartDisplay
                chartType="bar"
                title="Contestaciones enviadas vs Fechas"
                data={{
                  labels: finalLabels4, // Etiquetas dinámicas basadas en el rango
                  datasets: [
                    {
                      label: "Cantidad",
                      data: finalData4, // Datos dinámicos basados en el rango
                      backgroundColor: "rgba(164, 77, 223, 0.5)",
                      borderColor: "rgb(33, 4, 66)",
                      borderWidth: 1,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { position: "top" },
                  },
                }}
              />
            </Box>
          </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MainConstestaciones;
